import Button from '../Button/Button';
import RevealImage from '../RevealImage/revealImage';
import useInView from '../UseInView/useInView';
import styles from './cta.module.scss';

const Cta = () => {
    const [experienceRef, experienceVisible] = useInView();

    return (
        <div className={styles.container}>
            <div
                id='Experience'
                ref={experienceRef}
                className={`${styles.containerLeft} ${experienceVisible ? styles.visible : ''}`}
            >
                <div>
                    <p>[CTA]</p>
                    <h1>Let’s Manage What Matters—Together.</h1>
                    <Button buttonText='Contact Us' displayIcon={true} link='/contact' />
                </div>
                <div className={styles.containerLeftBottom}>
                    <div className={styles.containerLeftBottomItems}>
                        <h2>5+</h2>
                        <h4>Years of Experience</h4>
                    </div>
                    <div className={styles.containerLeftBottomItems}>
                        <h2>100+</h2>
                        <h4>Properties</h4>
                    </div>
                    <div className={styles.containerLeftBottomItems}>
                        <h2>98%</h2>
                        <h4>Client Satisfaction Rate</h4>
                    </div>
                </div>
            </div>
            <div className={styles.containerRight}>
                <RevealImage
                    src='https://plus.unsplash.com/premium_photo-1683140951041-2bedaa8492aa?q=80&w=2085&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                    alt='landing'
                    imageStyle={{
                        width: 'min(100vw, 600px)',
                    }}
                    rollUpColor='#f6f6f6'
                />
            </div>
        </div>
    );
};

export default Cta;
